import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './popUp.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import pup1 from '../../assets/pup1.jpg';
import pup2 from '../../assets/pup2.jpg';
import pup3 from '../../assets/pup3.jpg';
import pup4 from '../../assets/pup4.jpg';
import pup5 from '../../assets/pup5.jpg';
import bdpup from '../../assets/bdpup.jpg';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


function Popup() {
  const popUpHeadings = ["What's new...", "Minimal design", "Multi page route","Credits and Gratitude", "Let's connect!"];
  const popUpImgs = [pup1, pup2, pup3, pup4, pup5];
  const popUpTexts = [
    "Explore my revamped portfolio, showcasing a web-app that fuses frontend artistry with adept problem-solving skills. Welcome to innovation redefined.",
    "Explore my portfolio's minimalistic design for an elegant journey. Uncover one of my most intricate frontend achievements yet, a true testament to mastering complexity.",
    "2023 Version Introduces Multi-Page Functionality for Enhanced Clarity. Say goodbye to limitations.",
    "Drawing inspiration from Denniss Nellenberg's remarkable work, and heartfelt thanks to Bhavesh for invaluable role in refining my work .",
    "Social account links..."
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [showBirthday, setShowBirthday] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [message, setMessage] = useState('');
  const [messageError, setMessageError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [successPopValue, setSuccessPopValue] = useState(0);
  const [showError, setShowError] = useState(false);



  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowPopup(true);
    }, 3500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleNextClick = () => {
    const nextIndex = (currentIndex + 1) % popUpHeadings.length;
    setCurrentIndex(nextIndex);
  };

  const handlePreviousClick = () => {
    if (!isFirstElement) {
      const previousIndex = (currentIndex - 1 + popUpHeadings.length) % popUpHeadings.length;
      setCurrentIndex(previousIndex);
    }
  };

  const handleCloseClick = () => {
    setShowPopup(false);
    setShowBirthday(false);
  };

  const handleBdPopup = () => {
    const currentDate = new Date();
    if (currentDate.getMonth() === 8 && currentDate.getDate() === 3) {
      const timeout = setTimeout(() => {
        setShowBirthday(true);
      }, 500);
      return () => {
        clearTimeout(timeout);
      };  
    }
  };

  const handleCloseAndBdPopup = () => {
    handleCloseClick();
    handleBdPopup();
  };

  const currentHeading = popUpHeadings[currentIndex];
  const currentText = popUpTexts[currentIndex];
  const currentImg = popUpImgs[currentIndex];
  const isLastElement = currentIndex === popUpHeadings.length - 1;
  const isFirstElement = currentIndex === 0;

  function handleEmailChange(event) {
    setEmail(event.target.value);
    setSuccessMessage(null);
    if (!event.target.value.match(/^[A-Za-z._\-0-9]*[@][A-Za-z]*[.][a-z]{2,4}$/)) {
      setEmailError('Please enter a valid email.');
    } else {
      setEmailError('');
    }
  }

  function handleMessageChange(event) {
    setMessage(event.target.value);
    setSuccessMessage(null);
    if (!event.target.value) {
      setMessageError('Please enter a message');
    } else {
      setMessageError('');
    }
  }

  const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
  }


  function sendBdMessage(e) {
    e.preventDefault();
    let hasError = false;
    if (!email.match(/^[A-Za-z._\-0-9]*[@][A-Za-z]*[.][a-z]{2,4}$/)) {
      setEmailError('Please enter a valid email');
      hasError = true;
    }
    if (!message) {
      setMessageError('Please enter a message');
      hasError = true;
    }
    if (!hasError) {
      setSubmitting(true);
      const data = {
        email,
        message
      };
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({'form-name': 'birthdayMessage', ...data})
      })
        .then(() => {
          setSubmitting(false);
          setSuccessMessage('Thank you! Your message has been sent.');
          e.target.reset();
          setEmail('');
          setMessage('');
          setShowSuccessPopUp(true);
          setShowError(false);
          setShowPopup(false);
          setShowBirthday(false);      
          setTimeout(() => {
            setShowSuccessPopUp(false);
          }, 3000);
        })
        .catch(error => {
          setSubmitting(false);
          setSuccessMessage('There was an error sending your message. Please try again later.');
          console.error(error);
        });
    }else{
      setSuccessMessage('Please enter necessary details!');
      setShowSuccessPopUp(true);
      setShowError(true);
      setTimeout(() => {
        setShowSuccessPopUp(false);
      }, 3000);
    }
  }

  useEffect(()=>{
    if(showSuccessPopUp){
      const interval = setInterval(() => {
                setSuccessPopValue(prevScale => Math.min(prevScale + 0.01, 1));
            }, 10);
        return () => clearInterval(interval);
        } else {
            const interval = setInterval(() => {
                setSuccessPopValue(prevScale => Math.max(prevScale - 0.01, 0));
            }, 10);
        return () => clearInterval(interval);
    }
  },[showSuccessPopUp])

  useEffect(() => {
    if (showPopup || showBirthday) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
}, [showPopup, showBirthday]);


  return (
    <>
      {showPopup && (
      <div className='pop-up'>
          <div className="pop-up-container">
            <div className="pop-container-top">
              <div className="pop-up-img-wrap">
                <img src={currentImg} alt="" />
              </div>
            </div> 
            <div className="pop-container-bot">
              <div className="pop-up-text">
                <h2>{currentHeading}</h2>
                <h3>{currentText}</h3>
                {isLastElement && (
                  <div className="pop-up-socials">
                    <Link to="https://www.linkedin.com/in/bibhu-ni" target="_blank" rel="noreferrer"><LinkedInIcon/></Link>
                    <Link to="https://github.com/Bibhuni" target="_blank" rel="noreferrer"><GitHubIcon/></Link>
                    <Link to="https://www.instagram.com/beee_vu/" target="_blank" rel="noreferrer"><InstagramIcon/></Link>
                    <Link to="https://www.facebook.com/people/Bibhu-Prasad-Sahoo/100007464406805/" target="_blank" rel="noreferrer"><FacebookIcon/></Link>
                    <Link to="https://twitter.com/Bibhupr77888" target="_blank" rel="noreferrer"><TwitterIcon/></Link>
                  </div>
                )}
              </div>
            </div>
            <div className="pop-up-btns">
                <p className={isFirstElement ? 'first-element' : ''} onClick={handlePreviousClick}>
                  <ArrowBackIosIcon/> Previous
                </p>
              {isLastElement ? (
                <p onClick={handleCloseAndBdPopup}>Close</p>
              ) : (
                <p onClick={handleNextClick}>Next<ArrowForwardIosIcon/></p>
              )}
            </div>
          </div>
        </div>
        )}
        {showBirthday && (
          <div className='pop-up'>
            <div className="pop-up-container bd">
              <div className="pop-container-top">
                <div className="pop-up-img-wrap">
                  <img src={bdpup} alt="" />
                </div>
              </div> 
              <div className="pop-container-bot">
                <div className="pop-up-text">
                  <h2>Hye! its 3rd september..</h2>
                  <h3 className='bd-text'>Want to send me a birthday wish?</h3>
                </div>
              </div>
              <form className="birthday-message" action='' onSubmit={sendBdMessage} method='POST' name='birthdayMessage'>
              <input type='hidden' name='form-name' value='birthdayMessage' />
                <div className="bd-inputs">
                  <div className="bd-input-box">
                    <span>Your email*</span>
                    <input autoComplete="off" placeholder='john@doe.com *' type="text" onChange={handleEmailChange} name='email'/>
                    <p className='bd-error-txt'>{emailError}</p>
                  </div>
                  <div className="bd-input-box">
                    <span>Birthday wish*</span>
                    <input autoComplete="off" placeholder='Happy birthday...*' type="text" onChange={handleMessageChange} name='message'/>
                    <p className='bd-error-txt'>{messageError}</p>
                  </div>
                </div>
              <div className="pop-up-btns">
                    {submitting ? (
                    <button disabled>
                      <p>Sending...</p>                  
                    </button>
                    ):(
                    <button type='submit'>
                      <p>Send now</p>
                    </button>
                    )}
                  <p onClick={handleCloseClick}>No thanks</p>
              </div>
              </form>
            </div>
          </div>
        )}
          <div className="bd-sucess-pop-up" style={{ transform: `translateX(${successPopValue * 20}px)`, opacity: successPopValue }}>
              <div className="sucess-wrap bd-wrap"  style={showError ? { color: 'red' } : { color: '#3ea30f' }}>
                  <div className="sucess-pop-left">
                      <CheckCircleIcon/>
                    </div>
                    <div className="sucess-pop-right bd-rt">
                      {successMessage}
                  </div>
              </div>
            </div>
    </>
  )
}

export default Popup;
